export const boxExpired = (userData) => userData?.subscriptionState === 'EXPIRED';
